import * as THREE from "three";
import type { RaycastHit } from "@craftgaming/shared";

export type BlockHighlight = {
  update: (hit: RaycastHit | null) => void;
  dispose: () => void;
};

export function createBlockHighlight(scene: THREE.Scene): BlockHighlight {
  // Slightly oversized box to avoid z-fighting
  const geometry = new THREE.BoxGeometry(1.005, 1.005, 1.005);
  const edges = new THREE.EdgesGeometry(geometry);
  const material = new THREE.LineBasicMaterial({
    color: 0x000000,
    transparent: true,
    opacity: 0.5,
  });
  const mesh = new THREE.LineSegments(edges, material);
  mesh.visible = false;
  scene.add(mesh);

  function update(hit: RaycastHit | null) {
    if (!hit) {
      mesh.visible = false;
      return;
    }
    mesh.position.set(hit.blockX + 0.5, hit.blockY + 0.5, hit.blockZ + 0.5);
    mesh.visible = true;
  }

  function dispose() {
    scene.remove(mesh);
    geometry.dispose();
    edges.dispose();
    material.dispose();
  }

  return { update, dispose };
}
